<template>
    <div>{{ text }}</div>
</template>


<script>
export default {
    name: "text-action-result",
    props: {
        action: {
            type: Object,
            required: true,
        },
    },
    computed: {
        text() {
            return this.action.text === "" ? "..." : this.action.text;
        },
    },
};
</script>